import React from 'react';
import Calculator from './components/Calculator';
import Login from './components/Login';
import styles from './styles/App.module.css';
import FlightCalculationsProvider from './contexts/FlightCalculationsContext';
import AuthProvider, { useAuth } from './contexts/AuthContext';

// Loading spinner component for auth state transitions
const LoadingSpinner: React.FC = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.spinner}></div>
    <p>Loading...</p>
  </div>
);

// This component manages conditional rendering based on auth state
const AuthenticatedApp: React.FC = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();

  // Show loading spinner while checking auth state
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Show main app if authenticated
  return (
    <div className={styles.app}>
      <header className={styles.appHeader}>
        {/* Removed logout button from here */}
      </header>
      <main>
        <FlightCalculationsProvider>
          <Calculator />
        </FlightCalculationsProvider>
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <p>&copy; {new Date().getFullYear()} Drone Light Show Calculator</p>
          <div className={styles.logoutContainer}>
            <button onClick={logout} className={styles.logoutButton}>
              Log Out
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Main App component wraps everything with the AuthProvider
function App() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
    </AuthProvider>
  );
}

export default App;
